import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { withLoaderPolicy } from '@shared/utilities/http-loader-context.util';
import { REMINDERS_API } from '@shared/constants/api/api-notes-reminders.constants';
import { Reminder, RemindersListParams } from '@shared/models/notes-reminders/notes-reminders.model';

@Injectable({
  providedIn: 'root'
})
export class RemindersService {  
  private updateHeaderReminders$ = new Subject<void>();

  constructor(
    private http: HttpService,
    private httpClient: HttpClient
  ) { }

  updateHeaderReminders() {
    this.updateHeaderReminders$.next();
  }

  onUpdateHeaderReminders() {
    return this.updateHeaderReminders$.asObservable();
  }

  transformToHttpParams(params:any){
    let paramsHttp = new HttpParams();
    (Object.keys(params) as (keyof RemindersListParams)[]).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        paramsHttp = paramsHttp.set(key, value.toString());
      }
    });

    return paramsHttp;
  }

  listReminders(params:RemindersListParams): Observable<any>{
    return this.http.get(REMINDERS_API.REMINDERS, params);
  }

  downloadReminders(params:RemindersListParams):Observable<any>{
    return this.httpClient.get(REMINDERS_API.REMINDERS_DOWNLOAD, withLoaderPolicy({ 
        params: this.transformToHttpParams(params),
        observe: 'response',
        responseType: 'blob',
      }, 'suppress'));
  }

  addReminders(params: {
    clientId: string,     
    customerId: number,
    assignedUser: string,
    followUpDate: string,
    reminder: string,
    comments: string,
    status: number
  }): Observable<any> {
    return this.http.post(REMINDERS_API.REMINDERS, { ...params }, { loader: 'force' });
  }

  getReminder(params: {
    clientId: string,
    reminderId: number,
  }): Observable<Reminder> {
    return this.http.put(REMINDERS_API.REMINDERS, {...params});
  }

  updateReminder(params: {
    clientId: string,   
    reminderId: number,  
    customerId: number,
    assignedUser: string,
    followUpDate: string,
    reminder: string,
    comments: string,
    status: number
  }): Observable<any>{
    return this.http.patch(REMINDERS_API.REMINDERS, {...params});
  }
}